
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/labels/[slug]/newest-packs",
      function () {
        return require("private-next-pages/labels/[slug]/newest-packs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/labels/[slug]/newest-packs"])
      });
    }
  